import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AirbnbQualityDashboardRepositoryService extends BaseRepositoryService<
  ModelRegistry['airbnb-quality-dashboard']
> {
  recordName = 'airbnb-quality-dashboard';
  implementMethods = ['queryRecord', 'unloadAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/airbnb-quality-dashboard': AirbnbQualityDashboardRepositoryService;
  }
}
